import { createSlice } from '@reduxjs/toolkit';
import { EService } from '../../shared/enums/EService';

interface IEnums {
  country: string[];
  language: string[];
  services: EService[];
}

const initialState: IEnums = {
  country: [],
  language: [],
  services: [],
};

const enumsSlice = createSlice({
  name: 'enums',
  initialState,
  reducers: {
    setEnums: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default enumsSlice;
